import * as R from 'ramda';

const propUnEq = (prop, value) => (obj) => !R.propEq(prop, value)(obj);

const includes = (a, list) => list.includes(a);

const argsToArr = (...args) => args;

const negateFunc = (f) => (...args) => !f(...args);

const cloneNotDeep = (some) => {
    switch (true) {
        case Array.isArray(some):
            return [...some];
        case typeof some === 'object' && some !== null:
            return { ...some };
        default:
            return some;
    }
};

const mergeWithMultipleObjects = (fn, [first, ...restObjects]) => {
    if (!restObjects.length) {
        return first;
    }

    // @ts-ignore
    return R.mergeWith(fn, first, mergeWithMultipleObjects(fn, restObjects));
};

export const RamdaExtender = {
    propUnEq,
    includes,
    argsToArr,
    negateFunc,
    cloneNotDeep,
    mergeWithMultipleObjects,
};
